import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { tap } from 'rxjs';

import { provideSystemHealthApi } from './data-access/system-health-api.token';
import { StatusPageConfigService } from './services/status-page-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch()),
    provideSystemHealthApi(),
    provideAppInitializer(() => {
      const config = inject(StatusPageConfigService);
      const title = inject(Title);

      return config.load().pipe(tap(loaded => title.setTitle(loaded.title)));
    }),
  ],
};
